export const appVersion = 'v1.0.1dev_20261105';
